// extracted by mini-css-extract-plugin
module.exports = {"container":"_2noGD","message":"_1gjkp","title":"_1SYnE","content":"_3ndHm","button":"_29AxW"};